import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { ES_AUTH_CONFIG, type EsAuthConfig } from './auth.config';
import { authInterceptor } from './auth.interceptor';

/**
 * Provide EchoSpaces auth for the app.
 *
 * Usage in app.config.ts or bootstrapApplication:
 * ```typescript
 * provideEsAuth({
 *   keycloakUrl: 'https://identity.echospaces.cloud',
 *   realm: 'echospaces',
 *   clientId: 'portal-client',
 *   redirectUri: window.location.origin,
 *   postLogoutRedirectUri: window.location.origin,
 *   scope: 'openid profile email',
 * })
 * ```
 */
export function provideEsAuth(config: EsAuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ES_AUTH_CONFIG, useValue: config },
    provideHttpClient(withInterceptors([authInterceptor, ...(config.httpInterceptors ?? [])])),
    provideOAuthClient(),
  ]);
}
